import { Box, Paper, PaperProps, Typography } from "@mui/material";
import CustomMDEditor from "../../../components/CustomMD/CustomMDEditor";
import CustomMDPreview from "../../../components/CustomMD/CustomMDPreview";
import { User } from "../../../types/User";
interface WorkHistoryProps {
    userData: User;
    setUserData: React.Dispatch<React.SetStateAction<User | null>>;
    editMode: boolean;
    paperProps?: PaperProps;
}

const WorkHistory = ({
    userData,
    setUserData,
    editMode,
    paperProps,
}: WorkHistoryProps) => {
    const handleDescriptionChange = (value?: string) => {
        setUserData((prevData) => {
            if (!prevData) return null;
            return {
                ...prevData,
                workHistory: value || ""
            };
        });
    };

    return (
        <Paper {...paperProps} sx={{ padding: 2, mb: 3, borderRadius: 2, ...paperProps?.sx }}>
            <Box>
                <Typography variant="h6" mb={3}>
                    Work History
                </Typography>
                {editMode ? (
                    <CustomMDEditor
                        value={userData.workHistory || ""}
                        onChange={handleDescriptionChange}
                        placeholder={
                            `Add your work history here`
                        }
                        customStyles={{
                            width: '100%',
                        }}
                    />
                ) : (
                    <CustomMDPreview description={userData.workHistory || "No Work History provided yet."} />
                )}
            </Box>
        </Paper>
    );
};

export default WorkHistory; 